_ = require('underscore')

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  components:
    'prevented-form':     require('../prevented_form')
    'loading-indicator':  require('../loading_indicator')
    'form-input':         require('../form/input')
    'form-textarea':      require('../form/textarea')
    'form-select':        require('../form/select')

  data: ->
    done:       false
    formData:   {}
    errors:     {}

  methods:

    onClickSubmit: ->
      @.$refs.form.submit()

    onClickFinancing: (option) ->
      @.$set @formData, 'financing', option

    resetDataToDefaults: ->
      @.$set @, 'formData', {
        salutation:       null
        firstname:        null
        lastname:         null
        company_name:     null
        phone:            null
        mail:             null
        website:          null
        message:          null
        amount_students:  null
        website_mention:  false
        forward_data:     false
        invoice_name:     null
        invoice_address:  null
        invoice_email:    null
      }
      @.$set @, 'errors', {}

    showLoadingIndicator: ->
      @.$refs.loadingIndicator.show()

    hideLoadingIndicator: ->
      @.$refs.loadingIndicator.hide()

    getErrorMessage: (attrName) ->
      return null unless _.any(@errors[attrName] || [])
      _.first(@errors[attrName])

    submit: ->
      gRecaptchaResponse = @.$refs.recaptcha.getRecaptchaResponse()
      return unless _.isString(gRecaptchaResponse) && _.size(gRecaptchaResponse) > 0

      @showLoadingIndicator()

      formData = @formData
      formData.website_mention  = formData.website_mention == true || formData.website_mention == 'true'
      formData.forward_data     = formData.forward_data == true || formData.forward_data == 'true'

      @.$store.dispatch('net/call', {
        method:   'post'
        url:      '/api/contact_form_become_partner'
        data:     { data: @formData, g_recaptcha_response: gRecaptchaResponse }
      })
      .then (response) =>
        data = response.data?.data || {}
        @.$set @, 'errors', data.errors || {}
        @.$set @, 'done', true unless _.size(@errors) > 0
      .catch (error) =>
        if error.response?.data?
          @.$set @, 'error', error.response.data.error
        else
          @.$set @, 'error', 'Fehler bei der Übermittlung der Daten'
      .finally =>
        @hideLoadingIndicator()
      .done()

  created: ->
    @resetDataToDefaults()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/contact_form_become_partner/index.coffee